import { render, staticRenderFns } from "./BasicAreaChart.vue?vue&type=template&id=e90576b8&"
import script from "./BasicAreaChart.vue?vue&type=script&lang=js&"
export * from "./BasicAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports